<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">Warning Letter (SP) Report</div>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div style="font-style: italic;color:red;">{{ $t('auth_report') }}
                    <Button :label="$t('click_here')" class="p-button p-component p-button-link" @click="showReportAuth()"
                        style="color: red;margin-bottom: -7px;margin-left: -10px;font-weight: bold;font-style: italic;text-decoration: underline;" />
                </div>
                <div v-if="header && this.Error_Message && !this.submitted">
                    <Message severity="warn" :closable="false" v-html="this.Error_Message">
                    </Message>
                </div>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Unit_Code" class="col-4">{{ $t('unit') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="UnitCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/unit_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Functional_Code" class="col-4">{{ $t('functional') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="FunctionalCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/functional_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Department_Code" class="col-4">{{ $t('department') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="DepartmentCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/department_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Grade_Code" class="col-4">{{ $t('grade') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="this.GradeCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/grade_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" />
                                </div>
                            </div>
                            <!-- <div class="field grid">
                                <label for="Section_Code" class="col-4">{{ $t('section') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="SectionCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/section_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div> -->
                            <div class="field grid">
                                <label for="Status" class="col-4">{{ $t('status_sp') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="Statuses" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/lookup'" :minLength="0"
                                        :params="{ group: 'STATUS_SP' }" :filter="true" :optionValue="'id'"
                                        :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Name" class="col-4">{{ $t('name') }}</label>
                                <div class="col-8 md-8">
                                    <InputText name="Name" v-model="header.Name" required="true" type="text"
                                        :placeholder="$t('name')" />
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="field grid">
                                <label for="Company_Code" class="col-4">{{ $t('company') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="CompanyCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/company_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Division_Code" class="col-4">{{ $t('division') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="DivisionCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/division_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Region" class="col-4">{{ $t('business_unit') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="Region" type="text" placeholder="All"
                                        :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: 'REGION' }"
                                        :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Directorate_Code" class="col-4">{{ $t('directorate') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="DirectorateCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/directorate_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" :optionLabel="'text'" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Period_Year" class="col-4">{{ $t('appraisal_period') }}</label>
                                <div class="col-8 md-8">
                                    <Dropdown v-model="header.Period_Year" :options="years" optionLabel="value"
                                        optionValue="value" :placeholder="$t('year')" />
                                </div>
                            </div>
                            <div class="field grid">
                                <label for="Job_Status_Code" class="col-4">{{ $t('jobStatus') }}</label>
                                <div class="col-8 md-8">
                                    <CustomMultiSelect class="p-inputtext-sm" v-model="this.JobStatusCode" type="text"
                                        placeholder="All" :url="this.$API_URL + 'list/job_status_code'" :minLength="0"
                                        :params="{}" :filter="true" :optionValue="'id'" />
                                    <small v-if="!this.JobStatusCode || this.JobStatusCode == ''" class="p-error">
                                        {{ $t('default_jobstatus') }}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Button type="button" label="Generate" @click="generate()" icon="pi pi-external-link" />
                &nbsp;
                <Button type="button" class="p-button-success" label="Export Excel" @click="exportExcel()"
                    v-show="this.reportTbl" icon="pi pi-file-excel" />
                <br /><br />
                <div v-html="this.reportTbl.content" v-if="this.reportTbl" style="overflow: auto;height: 100vh;" />
                <div v-html="this.reportTbl.content" v-if="this.excelTbl" v-show="false" />

            </template>
        </Card>
    </form>

    <ReportAuth v-if="reportAuth" :isVisible="reportAuth" :initialErrorMessage="errormessage"
        @hide="hideReportAuthDialog" />
</template>

<script>
export default {
    data() {
        return {
            test: 0,
            mode: "",
            dataUrl: "Report/warning_letter_report",
            reportTbl: null,
            excelTbl: null,
            showReport: false,
            loadingReport: false,
            Error_Message: "",
            mergedOptions: [
                { label: "Y", value: 1 },
                { label: "N", value: 0 },
            ],
            UnitCode: null,
            FunctionalCode: null,
            DepartmentCode: null,
            GradeCode: null,
            SectionCode: null,
            CompanyCode: null,
            DivisionCode: null,
            Region: null,
            DirectorateCode: null,
            JobStatusCode: null,
            Statuses: null,
            header: {
                Unit_Code: null,
                Functional_Code: null,
                Department_Code: null,
                Grade_Code: null,
                Section_Code: null,
                Company_Code: null,
                Division_Code: null,
                Job_Status_Code: null,
                Period_Year: new Date().getFullYear(),
                Region: null,
                Directorate_Code: null,
                Name: "",
                Status: ""
            },
            submitted: false,
            reportAuth: false
        };
    },
    methods: {
        reopenTab() {
            this.showReport = true;
        },
        resetBtn() {
            this.showReport = false;
        },
        tableToExcel() {
            this.loadingReport = !this.loadingReport;
        },
        generate() {
            this.Error_Message = "";

            if (!this.UnitCode && !this.FunctionalCode && !this.DepartmentCode && !this.GradeCode
                && !this.CompanyCode && !this.DivisionCode && !this.Region && this.header.Name == '' && !this.Statuses && !this.JobStatusCode) {
                this.Error_Message = "Pilih minimal 1 filter!";
            }
            else {
                this.header.Is_Export = false;
                this.getReport();
            }
        },
        getReport() {
            this.$emit('block-ui');

            this.header.Unit_Code = this.UnitCode ? this.UnitCode.join(',') : '';
            this.header.Functional_Code = this.FunctionalCode ? this.FunctionalCode.join(',') : '';
            this.header.Department_Code = this.DepartmentCode ? this.DepartmentCode.join(',') : '';
            this.header.Grade_Code = this.GradeCode ? this.GradeCode.join(',') : '';
            this.header.Section_Code = this.SectionCode ? this.SectionCode.join(',') : '';
            this.header.Company_Code = this.CompanyCode ? this.CompanyCode.join(',') : '';
            this.header.Division_Code = this.DivisionCode ? this.DivisionCode.join(',') : '';
            this.header.Region = this.Region ? this.Region.join(',') : '';
            this.header.Directorate_Code = this.DirectorateCode ? this.DirectorateCode.join(',') : '';
            this.header.Status = this.Statuses ? this.Statuses.join(',') : '';
            this.header.Job_Status_Code = this.JobStatusCode ? this.JobStatusCode.join(',') : '';

            this.$axios.post(this.$API_URL + this.dataUrl, this.header)
                .then((response) => {
                    if (response.data.success) {
                        if (this.header.Is_Export) {
                            this.excelTbl = {
                                header: response.data.data.header,
                                content: response.data.data.content,
                                title: response.data.data.title,
                            };

                            this.tableToExcel();
                        }
                        else {
                            this.reportTbl = {
                                header: response.data.data.header,
                                content: response.data.data.content,
                                title: response.data.data.title,
                            };
                        }
                    }

                    this.$emit('unblock-ui');
                })
                .catch(() => {
                    this.$emit('unblock-ui');
                });
        },
        exportExcel() {
            this.Error_Message = "";

            if (!this.header.Unit_Code && !this.header.Functional_Code && !this.header.Department_Code && !this.header.Grade_Code
                && !this.header.Company_Code && !this.header.Division_Code && !this.header.Region && this.header.Name == '' && !this.header.Status && !this.header.Job_Status_Code) {
                this.Error_Message = "Pilih minimal 1 filter!";
            }
            else {
                this.header.Is_Export = true;
                this.getReport();
            }
        },
        tableToExcel() {
            var uri = "data:application/vnd.ms-excel;base64,",
                template =
                    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
                base64 = function (s) {
                    return window.btoa(unescape(encodeURIComponent(s)));
                },
                format = function (s, c) {
                    return s.replace(/{(\w+)}/g, function (m, p) {
                        return c[p];
                    });
                };
            var ctx = {
                worksheet: "Default" || "Worksheet",
                table: this.excelTbl.header + this.excelTbl.content,
            };
            var currentDate = this.$moment().format("DD-MM-yyyy_hh-mm");
            var fileName = this.excelTbl.title + "_" + currentDate;
            const link = document.createElement("a");
            link.href = uri + base64(format(template, ctx));
            link.download = fileName;
            link.click();
        },
        showError() {
            this.loadingReport = !this.loadingReport;
        },
        closeReport() {
            this.showReport = false;
        },
        showReportAuth() {
            this.reportAuth = true;
        },
        hideReportAuthDialog() {
            this.reportAuth = false;
        }
    },
    mounted() { },
    computed: {
        years() {
            let years = [];
            for (var i = new Date().getFullYear(); i >= 2023; i--) {
                years.push({ value: i.toString() })
            }
            return years;
        },
    }
};
</script>
